module.exports = __webpack_public_path__ + "img/Ativo 2.62fce062.png";